module.exports = __webpack_public_path__ + "img/hohlsaum_kobaltblau_ral5013.01c483ac.jpg";